import { createSelector } from '@reduxjs/toolkit';

import { CombinedToolNames, ToggledToolNames } from '@/shared/config';

import { RootState } from '@/app/model/store';

import { ToolbarID } from '../config';

const selectToolbarMIR = (state: RootState) => state.toolbarMIR;

export const selectToolbarByID = (toolbarID: ToolbarID) =>
  createSelector(selectToolbarMIR, (toolbar) => toolbar[toolbarID]);

export const selectActiveTools = (toolbarID: ToolbarID) =>
  createSelector(
    selectToolbarByID(toolbarID),
    (toolbar): (CombinedToolNames | ToggledToolNames)[] => {
      return toolbar
        ? Object.entries(toolbar).reduce(
            (acc, [key, value]) => {
              if (typeof value === 'boolean' && value) {
                acc.push(key as CombinedToolNames);
              } else if (typeof value === 'string') {
                acc.push(value);
              }
              return acc;
            },
            [] as (CombinedToolNames | ToggledToolNames)[],
          )
        : [];
    },
  );

export const selectToolbarProperty = (
  toolbarID: ToolbarID,
  property: CombinedToolNames,
) =>
  createSelector(
    selectToolbarByID(toolbarID),
    (toolbar): boolean => toolbar?.[property] ?? false,
  );

export const selectIsEditingTeeth = (toolbarID: ToolbarID) =>
  createSelector(
    selectToolbarByID(toolbarID),
    (toolbar): boolean => toolbar?.editNumbers ?? false,
  );

export const selectIsEditingMask = (toolbarID: ToolbarID) =>
  createSelector(
    selectToolbarByID(toolbarID),
    (toolbar): boolean => toolbar?.activeControl === 'editMask',
  );
